import './index.scss';

const NotFound = () => <p>Không tìm thấy trang</p>;

export default NotFound;
